<template>
	<md-card>
        <md-card-content>
            <slot></slot>
        </md-card-content>
    </md-card>
</template>

<script>
	export default {
		name: 'container',
		data() {
			return {}
		},
		methods: {}
	}
</script>




// WEBPACK FOOTER //
// src/components/Container.vue